import React, { useEffect } from 'react';
import { useBiLogger } from '../hooks/useBiLogger/useBiLogger';
import { useHasMetasiteError, useResetStore } from '../store/appStore';
import { DsBuilderMethod } from '../types';
import { GeneralError } from '../components/GeneralError/GeneralError';
import { CategoriesRoot } from '../features/categories';
import { useGTM } from '../hooks/useGTM';

export type CategoryPageProps = {};

export const Categories: React.FC<CategoryPageProps> = () => {
  const metasiteError = useHasMetasiteError();
  const biLogger = useBiLogger();
  const { trackFunnelEntry } = useGTM();
  const resetStore = useResetStore();

  useEffect(() => {
    resetStore();

    biLogger.pageView(DsBuilderMethod[DsBuilderMethod.CATEGORY_PAGE]);
    trackFunnelEntry('categories'); // GTM tracking for funnel entry
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (metasiteError) {
    return <GeneralError />;
  }

  return <CategoriesRoot />;
};
